import React from 'react';
import Stack from 'react-bootstrap/Stack';
import LaunchUploadHeader from './launch-upload-header';
import LaunchUploadContent from './launch-upload-content';

function LaunchUpload({ selectionMade }) {
  return (
    <Stack gap={1} className="h-100">
      <LaunchUploadHeader />
      <LaunchUploadContent selectionMade={selectionMade} />
    </Stack>
  );
}

export default LaunchUpload;
